import { Col, Container, Row } from "reactstrap";
import { JobHereTitle } from "../../../constants";
import { JobHereContentData } from "../../../data/demo/JobDemo1";
import { useAppSelector } from "../../../reduxToolkit/hooks";
import CommonHeader from "../common/CommonHeader";
import JobProductBox1 from "../../commonComponents/productBox/JobProductBox1";

const JobHere = () => {
  const { productItem } = useAppSelector((state) => state.product);

  return (
    <section className="job-box-section section-b-space">
      <Container>
        <CommonHeader title={JobHereTitle} content={JobHereContentData} headClass="title-style-3 text-center" />
        <Row className="g-4">
          {productItem
            .filter((e) => [16, 17, 18, 19, 20, 21].includes(e.id))
            .map((job, index) => (
              <Col xl="4" md="6" data-aos="fade-up" data-aos-duration={200 * (index + 1)} key={index}>
                <JobProductBox1 data={job} />
              </Col>
            ))}
        </Row>
      </Container>
    </section>
  );
};

export default JobHere;
